<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-12 d-flex align-items-center">
      <ol class="breadcrumb flex-grow-1 mb-0">
        <li class="breadcrumb-item">
          <a>Home</a>
        </li>
        <li class="breadcrumb-item">
          <a>Support</a>
        </li> 
        <li class="breadcrumb-item">
            <div class="btn-group form-group-sm float-sm-right" dropdown>
                <a id="button-basic" dropdownToggle class="link" aria-controls="dropdown-basic">
                {{ticketQuery}}
                    <i class="fa fa-sort-asc"></i>
                </a>
                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                    <li role="menuitem">
                      <a class="dropdown-item" (click)="changeQuery('My Tickets')">My Tickets</a>
                      <a class="dropdown-item" (click)="changeQuery('Customer Tickets')">Customer Tickets</a>
                    </li>
                </ul>

              </div>
        </li>
      </ol>
      <button class="btn btn-xs btn-outline-primary" (click)="startCreateTicket();addTicket.show()"><i class="fa fa-plus"></i> Create Ticket</button>
    </div>
</div>
<div class="wrapper wrapper-content  animated fadeInRight">
  <div class="row mt-2 support-columns-row">
    <!-- BEGIN col-4 -->
     <!-- loop through each column in the order they were added to the dictionary -->

    <div class="col-xl-4 col-lg-6 slim" *ngFor="let column of columnsOrder">
      <!-- BEGIN card -->
      <div class="card mb-3 ticket-column-card">
        <!-- BEGIN card-header -->
        <div class="card-header d-flex align-items-center bg-inverse bg-opacity-10">
          <span class="flex-grow-1 fw-400">{{column}} ({{columns[column].length}})</span>
          <div class="form-check form-check-inline me-2 mb-0" *ngIf="column === 'Completed'">
            <input class="form-check-input" type="checkbox" id="showClosedTickets" [checked]="showClosedTickets" (change)="toggleClosedTickets()" />
            <label class="form-check-label text-inverse text-opacity-50 small" for="showClosedTickets">Show Closed</label>
          </div>
          <a (click)="toggleColumnSort(column)" class="text-inverse text-opacity-50 text-decoration-none me-2" [attr.title]="isColumnSortNewestFirst(column) ? 'Sort: Newest to Oldest' : 'Sort: Oldest to Newest'">
            <i class="bi" [ngClass]="isColumnSortNewestFirst(column) ? 'bi-sort-down' : 'bi-sort-up'"></i>
          </a>
          <a (click)="toggleColumnSlaSort(column)" class="text-inverse text-opacity-50 text-decoration-none me-2" [attr.title]="isColumnSlaSortHighestFirst(column) ? 'Sort SLA: Highest to Lowest' : 'Sort SLA: Lowest to Highest'">
            <i class="bi" [ngClass]="isColumnSlaSortHighestFirst(column) ? 'bi-sort-numeric-down' : 'bi-sort-numeric-up'"></i>
          </a>
          <a (click)="ngOnInit()" class="text-inverse text-opacity-50 text-decoration-none"><i class="fa fa-fw fa-redo"></i></a>
        </div>
        <!-- END card-header -->
        <!-- BEGIN list-group -->
        <div class="bg-black bg-opacity-20 ticket-group sortable list-group list-group-flush" [sortablejs]="columns[column]" [sortablejsOptions]="options" [data-column]="column">
          <div class="list-group-item ticket-item" 
            [ngClass]="{
              'bg-opacity-30 bg-green': ticket.assignedToUser == azureAuthService.userProfile.fullName,
              'bg-opacity-10 bg-white': ticket.assignedToUser != azureAuthService.userProfile.fullName
            }" *ngFor="let ticket of columns[column]" [data-id]="ticket.id">
            <!-- BEGIN list-group-item -->
              <div class="ticket-sla-progress" *ngIf="shouldShowSlaClock(ticket)" [attr.title]="'SLA remaining: ' + (getDisplaySlaPercent(ticket) | number:'1.0-0') + '%'">
                <div class="ticket-sla-progress__fill"
                   [style.width.%]="getSlaProgressFillPercent(ticket)"
                     [ngClass]="getSlaProgressClass(ticket)"></div>
              </div>

              <div class="d-flex px-3 py-3 w-100">
              <div class="me-3 pt-1" >
                <i class="far fa-question-circle text-inverse text-opacity-50 fa-fw fa-lg"></i> 
                <br/>
                <i *ngIf="(ticket.description || (ticket.notes && ticket.notes.length > 0))"
                   class="fa fa-comment fa-fw fa-lg mt-2 ticket-toggle-btn"
                   [class.text-theme]="expandedTickets.has(ticket.id)"
                   [class.text-opacity-50]="!expandedTickets.has(ticket.id)"
                   (click)="toggleTicketDetail(ticket.id)"></i>
              </div>
              <div class="flex-fill">
                <div class="d-flex">
                  <div class="fw-400">{{ticket.title}}</div>
                  <div class="fw-400 ms-auto">
                    <button class="btn badge border border-secondary text-secondary" (click)="openEditTicket(ticket)">
                      <i class="fa fa-pencil"></i> Edit</button>
                  </div>
                </div>
                <div class="small text-inverse text-opacity-50 mb-2">#{{ticket.id}} opened {{ticket.createdDate | relativeDate}} by {{ticket.raisedByUser}}</div>

                <!-- Inline detail panel — hidden by default, toggled by the comment bubble -->
                <div class="ticket-detail-panel" [class.open]="expandedTickets.has(ticket.id)">
                  <div class="ticket-inline-desc" *ngIf="ticket.description">{{ticket.description}}</div>
                  <div class="ticket-inline-note" *ngIf="ticket.notes && ticket.notes.length > 0">
                    <span class="ticket-inline-note__by">{{ticket.notes[ticket.notes.length - 1].enteredByUser}}:</span>
                    {{ticket.notes[ticket.notes.length - 1].note}}
                  </div>
                </div>

                <div class="d-flex ticket-badges-row">
                  <!--<span class="badge border border-gray-300 text-inverse text-opacity-50">docs</span>-->
                  <div class="ticket-badges-left">
                    <span *ngIf="azureAuthService.isAdmin()" class="badge border border-info text-info mr-2 ticket-customer-badge">
                      <i class="bi bi-building"></i>
                      <span class="ticket-customer-badge__text">{{ticket.customerName}}</span>
                    </span>
                    <span class="badge border border-theme text-theme mr-2 ticket-static-badge">{{ticket.status.status}}</span>
                    <span class="badge border mr-2 ticket-static-badge" [ngClass]="{'text-success border-success':ticket.priority.id > 2, 'border-warning text-warning':ticket.priority.id == 2, 'border-danger text-danger':ticket.priority.id == 1}">{{ticket.priority.priority}}</span>
                  </div>
                  
                  <div class="fw-400 ms-auto ticket-badges-actions" *ngIf="ticket.status.id < 4">
                    <span class="badge border border-info text-info mr-2" *ngIf="ticket.assignedToUser != null">{{ticket.assignedToUser}}</span>
                    <button class="btn badge border border-secondary text-secondary" (click)="acceptOwnership(ticket)" *ngIf="ticket.assignedToUser == null && azureAuthService.isAdmin()">Accept Ownership</button>
                    <button class="btn badge border border-warning text-warning" (click)="acknowledgeTicket(ticket)" [disabled]="!canAcknowledgeTicket(ticket)" *ngIf="!isTicketAcknowledged(ticket)">Acknowledge</button>
                  </div>
                  <div class="fw-400 ms-auto ticket-badges-actions" *ngIf="ticket.status.id == 4">
                    <button class="btn badge border border-warning text-warning mr-2" (click)="acknowledgeTicket(ticket)" [disabled]="!canAcknowledgeTicket(ticket)" *ngIf="!isTicketAcknowledged(ticket)">Acknowledge</button>
                    <button class="btn badge border border-danger text-danger" (click)="closeTicket(ticket)" *ngIf="azureAuthService.isOwner() && azureAuthService.isAdmin()">Close Ticket</button>
                  </div>
                </div>

              </div>
              </div>
            
            <!-- END list-group-item -->       
          </div>
          <div class="ticket-empty" *ngIf="ticketsLoading">
            <span class="ticket-empty__spinner"></span>
            <div class="ticket-empty__text">Loading tickets&hellip;</div>
          </div>
          <div class="ticket-empty" *ngIf="!ticketsLoading && columns[column].length === 0">
            <i class="far fa-clipboard text-inverse text-opacity-25"></i>
            <div class="ticket-empty__text">No tickets</div>
          </div>
        </div>
        
      
      </div>
      <!-- END card -->
    </div>

    
   
  </div>
    
</div>


<div class="modal fade" bsModal #addTicket="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
          <h5 class="modal-title">NEW TICKET</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="addTicket.hide()"></button>
      </div>
      <div class="modal-body" *ngIf="newTicket">
          <div class="row g-3 ticket-edit-layout">
            <div class="col-lg-5 ticket-edit-col">
              <div class="form-group input-group-sm">
                  <label>Name</label>
                  <input class="form-control form-control-sm" [(ngModel)]="newTicket.title" placeholder="Enter ticket title" maxlength="100"/>
              </div>

              <div class="form-group input-group-sm">
                  <label>Priority</label>
                  <select class="form-select form-select-sm" [(ngModel)]="newTicket.priorityId">
                    <option *ngFor="let priority of priorityTypes" [value]="priority.id">{{priority.priority}}</option>
                  </select>
              </div>

              <div class="form-group input-group-sm" *ngIf="azureAuthService.isAdmin()">
                  <label>Customer</label>
                  <select class="form-select form-select-sm" [(ngModel)]="newTicketCustomerId">
                    <option *ngFor="let c of allCustomers" [value]="c.customerId">{{c.customerName}}</option>
                  </select>
              </div>
            </div>

            <div class="col-lg-7 d-flex">
              <div class="form-group input-group-sm ticket-description-group">
                  <label>Description</label>
                  <angular-editor
                    class="ticket-description-editor"
                    [config]="newTicketEditorConfig"
                    [(ngModel)]="newTicketDescriptionHtml"
                    (ngModelChange)="onNewTicketDescriptionEditorChange($event)">
                  </angular-editor>
              </div>
            </div>
          </div>

      </div>
      <div class="modal-footer">
        <button class="btn btn-w-m btn-outline btn-default" (click)="addTicket.hide()">Cancel</button>
        <button class="btn btn-w-m btn-outline btn-theme" (click)="createTicket();addTicket.hide()">Save</button>  
      </div>
    </div>
  </div>
</div>




<app-support-ticket-editor-modal
  #ticketEditor
  [selectedTicket]="selectedTicket"
  [priorityTypes]="priorityTypes"
  [statusTypes]="statusTypes"
  [allCustomers]="allCustomers"
  [users]="users"
  [(noteText)]="newNote"
  (saveTicket)="updateTicket($event)"
  (addNoteRequested)="addNote()"
  (acknowledgeTicket)="acknowledgeTicket($event)"
  (acceptOwnershipTicket)="acceptOwnership($event)"
  (closeTicket)="closeTicket($event)">
</app-support-ticket-editor-modal>